/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbFontSize12 = '12px'
export const SbFontSize14 = '14px'
export const SbFontSize16 = '16px'
export const SbFontSize17 = '17px'
export const SbFontSize18 = '18px'
export const SbFontSize19 = '19px'
export const SbFontSize21 = '21px'
export const SbFontSize22 = '22px'
export const SbFontSize24 = '24px'
export const SbFontSize25 = '25px'
export const SbFontSize28 = '28px'
export const SbFontSize30 = '30px'
export const SbFontSize33 = '33px'
export const SbFontSize34 = '34px'
export const SbFontSize40 = '40px'
export const SbFontSize48 = '48px'
